import React, {useState, useEffect} from 'react';
import axios from './axios';
import requests from './requests';
import './banner.css';

function Banner() {
    const [movie, setMovie]= useState([]);

    useEffect(() => {
        async function fetchData() {
            const request= await axios.get(requests.fetchNetflixOriginals);
            setMovie(
                request.data.results[
                    //this math gets one of the movies randomly for the top banner
                    Math.floor(Math.random()*request.data.results.length -1)
                ]
            );
            return request;
        }
        fetchData();
    }, []);

    function truncate(str, n){
        return str?.length>n ? str.substr(0, n-1) + "..." : str;
    }

  return (
    <header className="banner"
        style={{
            backgroundSize: "cover",
            backgroundImage: `url(
                "https://image.tmdb.org/t/p/original/${movie?.backdrop_path}"

            )`,
            backgroundPosition: "center center",
        }}
    >
        <div className="banner_contents">
        <h1 className="banner_title">
            {/* if else statements in one line for displaying movie */}
            {/* question mark handles errors */}
            {movie?.title || movie?.name || movie?.original_name}</h1>
        <div className="banner_buttons">
            <button className="banner_button">Play</button>
            <button className="banner_button">My List</button>
        </div>
        <h1 className="banner_description">{movie?.overview}
        {truncate(movie?.overview, 150)}
        </h1>
        </div>
        <div className="banner_fadebottom"/>
    </header>
  )
}

export default Banner